module.exports = __webpack_public_path__ + "media/images/flags/64/Uzbekistan-f87372952ac4db038eb79158ffc09f0c.png";